module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4-ufo711.9e9eaa93.png";